import React, { useState, useRef } from 'react';

import { ConfigProvider, Button, Select, Modal, DatePicker } from 'antd';
import ProTable from '@ant-design/pro-table';
import axios from '../../../utils/AxiosUtil'
import { useSelector } from 'react-redux'
import { recordCols } from '../../../constants/recordConstants'
import QueryBill from './query';
import UpdateBill from './update.tsx';
import { modalHint } from '../../../components/reqAndHint';
import 'moment/locale/zh-cn';
import locale from 'antd/lib/locale/zh_CN';

/**
 * 票据作业-票据列表
 */
const { Option } = Select;
const { RangePicker } = DatePicker;

export default () => {
    const actionRef = useRef();
    let col = [...recordCols];
    const [columns, setColumns] = useState(col);
    const [needSearchForm, setNeedSearchForm] = useState(true);//true表示搜索表单尚未动态加载
    // const [dataSource, setDataSource] = useState();
    const langValue = useSelector(state => state.langList.value)
    const [modalVisible, setModalVisible] = useState(false);
    const [modalType, setModalType] = useState(null);
    const [recordId, setRecordId] = useState();
    const [recordArea, setRecordArea] = useState();
    const [recordVolCnt, setRecordVolCnt] = useState();
    const [recordDate, setRecordDate] = useState();
    const [areaList, setAreaList] = useState([])




    // col.push(operCol);


    let winHeight;//窗口宽度，用于明细弹窗
    if (window.innerHeight) {
        winHeight = window.innerHeight;
    } else if ((document.body) && (document.body.clientHeight)) {
        winHeight = document.body.clientHeight;
    }
    // 中英文切换
    const getColumns = (col) => {
        let operCol = {
            title: '操作',
            en_title: 'Operation',
            ch_title: '操作',
            width: '90px',
            valueType: 'option',
            render: (text, record, _, action) => [
                <div style={{ display: 'flex', flexDirection: 'column', lineHeight: 'normal' }} key='handle'>
                    {record['票据状态'] != '已提交'
                        ? (<Button type="primary" ghost
                            key="editable"
                            style={{ marginBottom: '5px' }}
                            onClick={() => {
                                setModalType('update');
                                setModalVisible(true);
                                // setRecordId(record.recordId);
                                setRecordId(record._id);
                                setRecordArea(record['地区']);
                                setRecordVolCnt(record['志工人数']);
                                setRecordDate(record['录入日期']);
                            }}
                        >
                            {langValue == 0 ? '编辑Edit' : (langValue == 1 ? '编辑' : 'Edit')}
                        </Button>)
                        : (<Button type="primary" ghost
                            key="query"
                            onClick={() => {
                                setModalType('query');
                                setModalVisible(true);
                                // setRecordId(record.recordId);
                                setRecordId(record._id);
                                setRecordArea(record['地区']);
                                setRecordVolCnt(record['志工人数']);
                                setRecordDate(record['录入日期']);
                            }}
                        >
                            {langValue == 0 ? '查看View' : (langValue == 1 ? '查看' : 'View')}
                        </Button>)}
                    <Button type="primary" ghost
                        disabled={record['票据状态'] == '已提交'}
                        onClick={() => handleDelete(record._id)}
                        key='delete'
                    >
                        {langValue == 0 ? '删除Delete' : (langValue == 1 ? '删除' : 'Delete')}
                    </Button >
                </div>
                ,
            ],
        };
        let newCol = [...col];
        newCol.push(operCol)
        newCol.forEach((item, i) => {
            if (i == 1) {
                item.renderFormItem = () => {
                    return <RangePicker
                        locale={locale}
                        format="YYYY-MM-DD"
                        placeholder={langValue == 0 ? ['开始日期Start Date', '结束日期End Date'] : (langValue == 1 ? ['开始日期', '结束日期'] : ['Start Date', 'End Date'])}
                    />
                };
            }
            if (i == 4) {
                item.renderFormItem = () => {
                    return <Select defaultValue="" style={{ width: 300 }} showSearch>
                        <Option key="allarea" value="">{langValue == 0 ? '所有地区All Regions' : (langValue == 1 ? '所有地区' : 'All Regions')}</Option>
                        {areaList.map((area, i) => {
                            return <Option key={area} value={area}>{area}</Option>
                        })}
                    </Select>
                };
            }
            if (i == 6) {
                item.renderFormItem = () => {
                    return <Select defaultValue="" >
                        <Option key="all" value="">{langValue == 0 ? '所有状态All Status' : (langValue == 1 ? '所有状态' : 'All Status')}</Option>
                        <Option key="await" value="待提交">{langValue == 0 ? '待提交Waiting to Submit' : (langValue == 1 ? '待提交' : 'Waiting to Submit')}</Option>
                        <Option key="done" value="已提交">{langValue == 0 ? '已提交Submitted' : (langValue == 1 ? '已提交' : 'Submitted')}</Option>
                        <Option key="back" value="被退回">{langValue == 0 ? '被退回Returned' : (langValue == 1 ? '被退回' : 'Returned')}</Option>
                    </Select>
                };
                item.render = (_, item2) => {
                    return langValue == 0 ? <span>{item2.ch_status}<br />{item2.en_status}</span> : (langValue == 1 ? item2.ch_status : item2.en_status)
                }
            } else if ((i != 1) && (i != 4)) {
                item.renderFormItem = () => { return null };
            }
            item.title = langValue == 0 ? <>{item.ch_title}<br />{item.en_title}</> : (langValue == 1 ? item.ch_title : item.en_title)
        })
        return newCol;

    }
    //点击删除按钮
    const handleDelete = (recordId) => {
        Modal.confirm({
            title: langValue == 0 ? '确定删除？Are you sure to delete?' : (langValue == 1 ? '确定删除？' : 'Are you sure to delete?'),
            content: langValue == 0 ? <>被删除的内容将无法恢复<br />The deleted content will not be recoverable</> : (langValue == 1 ? '被删除的内容将无法恢复' : 'The deleted content will not be recoverable'),
            okText: langValue == 0 ? '确定Confirm' : (langValue == 1 ? '确定' : 'Confirm'),
            cancelText: langValue == 0 ? '取消Cancle' : (langValue == 1 ? '取消' : 'Cancle'),
            onOk: () => {
                axios.post('/fund/bill/deleteTemp', { recordId }).then((data) => {
                    var str = langValue == 0 ? (data.data.msg + data.data.en_msg) : (langValue == 1 ? data.data.msg : data.data.en_msg)
                    modalHint('success', str, () => {
                        // resetFormFields();
                        // console.log('删除成功:', recordId);
                        actionRef.current.reload();
                    });
                })
                    .catch((e) => {
                        const { msg, en_msg } = e ?.response ?.data
                        var str = langValue == 0 ? (msg + en_msg) : (langValue == 1 ? msg : en_msg)
                        modalHint('error', str, 'e:', e);
                    });
            }
        });
    }

    //重新查询并渲染票据列表
    const reloadRecordList = () => {
        // console.log('重新查询并渲染票据列表')
        actionRef.current.reload();
    }

    return (
        <div id="bill-list">
            <ProTable
                sticky
                columns={getColumns(columns)}
                // dataSource={dataSource}
                actionRef={actionRef}
                cardBordered
                // toolBarRender={false}
                //工具栏选项
                options={{
                    density: true,
                    fullScreen: true,
                    reload: false,
                    setting: false,
                }}

                request={async (
                    // 第一个参数 params 查询表单和 params 参数的结合
                    // 第一个参数中一定会有 pageSize 和  current ，这两个参数是 antd 的规范
                    params: {
                        pageSize: number;
                        current: number;
                    },
                    sort,
                    filter,
                ) => {
                    // 这里需要返回一个 Promise,在返回之前你可以进行数据转化
                    // 如果需要转化参数可以在这里进行修改
                    // console.log('pro table params:', params, ' sort:', sort, ' filter:', filter);
                    const coverParams = (params) => {
                        let p = { ...params, uid: sessionStorage.getItem('uid') };
                        let { nameOrAccount } = { nameOrAccount: params['账号'] };
                        if (nameOrAccount) {
                            p = { ...p, nameOrAccount };
                        }

                        // console.log('coverParams:', p);
                        return p;
                    }

                    const data = await axios.post('/fund/bill/list', coverParams(params));
                    const { billRecordList, dateList, statusList } = data.data;
                    // console.log("bill record list data:", data.data);
                    const statusObj = {
                        '待提交': 'Waiting to Submit',
                        '已提交': 'Submitted',
                        '被退回': 'Returned'
                    }
                    let dataSrc = [...billRecordList];
                    dataSrc.forEach((d, i) => {
                        // d.key = i + 1;
                        d['序号'] = i + 1;
                        d.key = i + 1;
                        d.ch_status = d['票据状态']
                        d.en_status = statusObj[d.ch_status]
                        // d._id = i + 1;
                    });
                    if (data.data.areaList && data.data.areaList.length) {
                        // console.log(data.data.areaList);
                        setAreaList(data.data.areaList)
                    }
                    // if (needSearchForm) {
                    //     //动态搜索表单，只在首次交互加载
                    //     let col = [...columns.slice()];
                    //     col[1].renderFormItem = () => {
                    //         return <RangePicker
                    //             locale={locale}
                    //             format="YYYY-MM-DD"
                    //             placeholder={['开始日期', '结束日期']}
                    //         />
                    //     };
                    //     col[4].renderFormItem = () => {
                    //         return <Select defaultValue="" style={{ width: 300 }} showSearch>
                    //             <Option key="allarea" value="">{langValue==0?'所有地区All Regions':(langValue==1?'所有地区':'All Regions')}</Option>
                    //             {areaList.map((area, i) => {
                    //                 return <Option key={area} value={area}>{area}</Option>
                    //             })}
                    //         </Select>
                    //     };
                    //     // if (dateList && dateList.length) {
                    //     //     col[1].renderFormItem = () => {
                    //     //         return <RangePicker
                    //     //             locale={locale}
                    //     //             format="YYYY-MM-DD"
                    //     //             placeholder={['开始日期', '结束日期']}
                    //     //         />
                    //     //     };
                    //     // }
                    //     // if (areaList && areaList.length) {
                    //     //     col[4].renderFormItem = () => {
                    //     //         return <Select defaultValue="" style={{ width: 300 }} showSearch>
                    //     //             <Option key="allarea" value="">所有地区</Option>
                    //     //             {areaList.map((area, i) => {
                    //     //                 return <Option key={area} value={area}>{area}</Option>
                    //     //             })}
                    //     //         </Select>
                    //     //     };
                    //     // }
                    //     setNeedSearchForm(false);
                    //     setColumns(col);
                    // }

                    return {
                        data: dataSrc,
                        // success 请返回 true，
                        // 不然 table 会停止解析数据，即使有数据
                        success: true,
                        // 不传会使用 data 的长度，如果是分页一定要传
                        total: dataSrc.length,
                    };
                }}
                editable={{
                    type: 'multiple',
                }}
                columnsState={{
                    persistenceKey: 'pro-table-singe-demos',
                    persistenceType: 'sessionStorage',
                }}
                rowKey="序号"
                search={{
                    labelWidth: 'auto',
                    span: '5',
                    collapseRender: false,
                    searchText: langValue == 0 ? '查询Query' : (langValue == 1 ? '查询' : 'Query'),
                    resetText: langValue == 0 ? '重置Reset' : (langValue == 1 ? '重置' : 'Reset'),
                }}
                pagination={{
                    pageSize: 10,
                    showQuickJumper: true,
                    showSizeChanger: true,
                    pageSizeOptions: [10, 20, 50, 100, 1000],
                }}
                dateFormatter="string"
                headerTitle={langValue == 0 ? "票据列表 Ticket List" : (langValue == 1 ? "票据列表" : 'Ticket List')}
                // toolBarRender={() => [
                //     <Button key="button" icon={<PlusOutlined />} type="primary">
                //         新建
                //     </Button>,
                //     <Dropdown key="menu" overlay={menu}>
                //         <Button>
                //             <EllipsisOutlined />
                //         </Button>
                //     </Dropdown>,

                // ]}
                recordCreatorProps={{
                    // 要增加到哪个节点下，一般用于多重嵌套表格
                    // parentKey: React.key,
                    // 顶部添加还是末尾添加
                    position: 'bottom',
                    // 新增一行的方式，默认是缓存，取消后就会消失
                    // 如果设置为 dataSource 会触发 onchange，取消后也不会消失，只能删除
                    newRecordType: 'dataSource',
                    // 不写 key ，会使用 index 当行 id
                    record: {},
                    // 设置按钮文案
                    creatorButtonText: '新增一行**',
                    // 按钮的样式设置，可以设置按钮是否显示
                    // 这样可以做最大行限制和最小行限制之类的功能
                    style: {
                        display: 'none',
                    },

                }}
                onRequestError={(error) => {
                    error = typeof error == 'object' ? JSON.stringify(error) : error;
                    Modal.error({ title: '表格加载错误', content: error });
                }}
            />
            <Modal
                centered
                visible={modalVisible}
                onOk={() => setModalVisible(false)}
                onCancel={() => setModalVisible(false)}
                width={'100%'}
                footer={false}
                bodyStyle={{ minHeight: winHeight }}
                destroyOnClose={true}//关闭时清空（重新加载子组件）
                maskClosable={false}//点击遮罩不关闭
                closable={false}//不显示右上角的关闭按钮（X)

            >
                {modalType == 'update'
                    ? <UpdateBill recordId={recordId}
                        recordArea={recordArea}
                        recordDate={recordDate}
                        setModalVisible={setModalVisible}
                        reloadRecordList={reloadRecordList}
                    />
                    : <QueryBill recordId={recordId}
                        recordArea={recordArea}
                        recordVolCnt={recordVolCnt}
                        recordDate={recordDate}
                        setModalVisible={setModalVisible}
                    />
                }
            </Modal>
        </div>
    );
};     